export const environment = {
  // API: 'http://surveyapp.knowledgelens.com/momentZS_v1.9/',
  // http://momentzs-dev.knowledgelens.com/test_v4.0/
  // API: 'http://momentzs-dev.knowledgelens.com/test_v4.0/',
  // API: 'https://surveyapp.knowledgelens.com/momentZS_v2.0/',
  // API: 'https://api.mzs-ci.dev.zsservices.com/',
  // API: 'https://api.mzs-ci.zsservices.com/',
   API: 'https://mzs-ci.zsservices.com/services/',
  REPORTAPI: 'https://mzs-ci.zsservices.com/reports/',
  // API: 'https://surveyapp.knowledgelens.com/momentZS_v2.0/',
  firebase: {
    apiKey: "AIzaSyDNE70ks-OPSKRmbGqMbVhoF0JGqmLtizs",
    authDomain: "g0169-zs-momentzs-prod-app.firebaseapp.com",
    databaseURL: "https://g0169-zs-momentzs-prod-app-default-rtdb.firebaseio.com",
    projectId: "g0169-zs-momentzs-prod-app",
    storageBucket: "g0169-zs-momentzs-prod-app.appspot.com",
    messagingSenderId: "128212683766",
    appId: "1:128212683766:web:d18efc62150b261f86d5d7",
    measurementId: "G-N7WSD56CYJ"
  },
  production: true
};
